import { render } from "./Heads.vue?vue&type=template&id=30c397ce"
import script from "./Heads.vue?vue&type=script&lang=js"
export * from "./Heads.vue?vue&type=script&lang=js"

import exportComponent from "/home/appfloretcollegein/app.floretcollege.in/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__